import React, { Component } from 'react'
import {
    withRouter
  } from 'react-router-dom'
  
class redirectRegistrationComponent extends Component {
    constructor(props) {
        super(props);
        this.state={
            userRadio:true,
            adminRadio:false,
            heartrunner:false,
        }
    }
    changeRegistration=(events,redirectUser)=>{
        //debugger
        let name=events.target.name;
        this.setState({[name]:redirectUser})
        let url='/'+redirectUser
        this.props.history.push(url)
        console.log(this.state)
    }
    render(){
        return (
            <div>
                <input 
                    type="radio" 
                    name="userRadio" 
                    className="k-radio" 
                    id="userRegister" 
                    //checked={1==1?true:false} 
                    onChange={(e)=>{this.changeRegistration(e,'registration')}} 
                />
                <label className="k-radio-label">USER</label> &nbsp;&nbsp;&nbsp;&nbsp;
                
                <input 
                    type="radio" 
                    name="adminRadio" 
                    className="k-radio" 
                    id="adminRegister" 
                    checked={this.state.adminRadio=='organization'?true:false} 
                    onChange={(e)=>{this.changeRegistration(e,'organization')}} 
                />
                <label className="k-radio-label">ORGANIZATION</label>
                <input 
                    type="radio" 
                    name="heartrunner" 
                    className="k-radio" 
                    checked={this.state.heartrunner=='heartrunner'?true:false} 

                    id="heartRunnerRegister" 
                    onChange={(e)=>{this.changeRegistration(e,'heartrunner')}} 
                />
                <label className="k-radio-label">HEART RUNNER</label>
            </div>
        )
    }
}



export default withRouter(redirectRegistrationComponent);